export function omit(source, toOmit) {
    const result = { ...source };
    if (!Array.isArray(toOmit)) {
        toOmit = [toOmit];
    }
    toOmit.forEach(item => {
        Object.keys(item).forEach(key => {
            delete result[key];
        });
    });
    return result;
}
